import { CLASS_TYPE_TO_COVER } from 'constants/domain-specific';
import capitalize from 'lodash/capitalize';
import { Risk } from 'types/policy';

import { isDefined } from './isDefined';

export interface PremiumClauseType {
  title: string;
  subtitle: string;
  description: string;
}

const toTitleCase = (str: string) => str.replace(/\w+/g, capitalize);

/**
 * @description
 * Transforms an array of risks to a map of clauses grouped by their premium classes
 */
export const getPremiumClauses = (
  risks: Risk[]
): {
  [key: string]: PremiumClauseType[];
} => {
  if (risks.every((risk) => !risk.clauses)) throw new Error('Missing clause in risk');

  return risks
    .map((risk) =>
      risk.clauses
        ?.map((cw) =>
          cw.clauseWording.map((c) => ({
            title: CLASS_TYPE_TO_COVER[c.premiumClass],
            subtitle: c.clauseDescription ?? '',
            description:
              c.clauseWordingLines?.reduce((acc, val) => `${acc}${val.wording}\n`, '') ?? '',
          }))
        )
        .flat()
    )
    .flat()
    .filter(isDefined)
    .reduce<Record<string, Array<PremiumClauseType>>>(
      (acc, val) => ({
        ...acc,
        [toTitleCase(val!.title)]: [
          ...(acc?.[toTitleCase(val!.title)] || []),
          {
            title: toTitleCase(val!.title),
            subtitle: toTitleCase(val!.subtitle),
            description: val!.description,
          },
        ],
      }),
      {}
    );
};
